
export const tableHelpers = {
    methods: {
        timeDiffCat (startTime, category = null) {
            if (!startTime) return ['None', 'success']

            let x = new Date(startTime)
            let now = new Date()
            var timeDiff = now - x
            timeDiff /= 1000

            var seconds = Math.round(timeDiff)
            timeDiff = Math.floor(timeDiff / 60)

            var minutes = Math.round(timeDiff % 60)
            timeDiff = Math.floor(timeDiff / 60)

            var hours = Math.round(timeDiff % 24)
            timeDiff = Math.floor(timeDiff / 24)

            var days = Math.round(timeDiff % 365)
            timeDiff = Math.floor(timeDiff / 365)

            var years = timeDiff

            var dangerDays = 0
            var dangerHours = 0

            switch (category) {
                case 'approve':
                    dangerDays = 1
                    dangerHours = 47
                    break
                case 'contact':
                    dangerDays = 4
                    dangerHours = 95
                    break
                case 'check':
                    dangerDays = 1
                    dangerHours = 47
                    break
                case 'print':
                    dangerDays = 0
                    dangerHours = 23
                    break
                default:
                    dangerDays = 0
                    dangerHours = 0
                    break
            }


            if (years > 0) {
                return [years + (years > 1 ? ' Years ' : ' Year ') + 'ago', 'danger']
            } else if (days > dangerDays) {
                return [days + (days > 1 ? ' Days ' : ' Day ') + 'ago', 'danger']
            } else if (days > 0) {
                return [days + (days > 1 ? ' Days ' : ' Day ') + 'ago', 'success']
            } else if (hours > dangerHours) {
                return [hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago', 'danger']
            } else if (hours > 0) {
                return [hours + (hours > 1 ? ' Hrs ' : ' Hour ') + 'ago', 'success']
            } else if (minutes > 0) {
                return [minutes + (minutes > 1 ? ' Mins ' : ' Min ') + 'ago', 'success']
            } else if (seconds > 0) {
                return [seconds + (seconds > 1 ? ' sec ago' : 'just now'), 'success']
            }

            return ['Just Now', 'success']

        },
        timeDifference (startTime, category = null) {
            return this.timeDiffCat(startTime, category)[0]
        },
        statusLabel (data) {
            if (data.in_storage) return ['In Storage', ['In Storage Date', data.in_storage_date]]
            if (data.sent_to_storage) return ['Sent to Storage', ['Sent to Storage Date', data.sent_to_storage_date]]
            if (data.sent_to_user) return ['Sent to User', ['Sent to User Date', data.sent_to_user_date]]
            if (data.sent_to_business) return ['Sent to Business', ['Sent to Business Date', data.sent_to_business_date]]
            return ['Created', ['Created Date', data.created_date]]
        },
        typeLabel (data) {
            if (data.will) return 'Will'
            if (data.lpa) return 'LPA'
            if (data.property_deeds) return 'Property Deeds'
            if (data.trust) return 'Trust'
        },
    }

}
